let isExitCheck = false // 離脱チェックを行う

window.addEventListener('input', function (e) {
  const item = e.target.closest('.mainWrap')
  if (!item) {
    return
  }

  window.addEventListener(
    'input',
    function (e) {
      isExitCheck = true
      window.exitAlert() // 離脱確認を予約する
    },
    {
      once: true, // 1度だけのイベントにする
    }
  )
})
if (document.getElementsByClassName('js-formExit')[0]) {
  window.addEventListener(
    'input',
    function (e) {
      isExitCheck = true
      window.exitAlert() // 離脱確認を予約する
    },
    {
      once: true, // 1度だけのイベントにする
    }
  )
}

// 送信時は動作させない
window.addEventListener('click', function (e) {
  const item = e.target.closest('[type="submit"]')
  if (!item) {
    return
  }
  isExitCheck = false
})

window.exitAlert = function () {
  window.addEventListener('beforeunload', function (e) {
    if (isExitCheck) {
      e.preventDefault()
      return
    }
  })
}
